import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const SearchRedirect = ({ searchTerms, searchEngine = "google" }) => {
  const navigate = useNavigate();
  
  useEffect(() => {
    let baseUrl;
    switch (searchEngine.toLowerCase()) {
      case "bing":
        baseUrl = "https://www.bing.com/search";
        break;
      case "duckduckgo":
        baseUrl = "https://duckduckgo.com/";
        break;
      case "google":
      default:
        baseUrl = "https://www.google.com/search";
    }

    const formattedTerms = encodeURIComponent(searchTerms);
    
    const searchUrl = `${baseUrl}?q=${formattedTerms}`;

    window.location.href = searchUrl;
        
  }, [searchTerms, searchEngine, navigate]);

  return (
    <div>Redirecting to search results...</div>
  );
};

export default SearchRedirect;